export const LEGACY_SIM_PRICING_MODELS = ['Regular', 'Full service']

export function normalizeSimTeamLinkValue(value) {
  if (value == null) return ''
  return String(value).trim()
}

export function getTeamLinkLabel(team = {}) {
  return String(team.teamName || team.name || '').trim()
}

export function findTeamBySimLinkValue(value, teams = []) {
  const normalizedValue = normalizeSimTeamLinkValue(value)
  if (normalizedValue.length === 0 || !Array.isArray(teams)) return null

  for (const team of teams) {
    const teamLabel = getTeamLinkLabel(team)
    if (normalizedValue === String(team.uuid || '').trim()) return team
    if (teamLabel.length > 0 && normalizedValue === teamLabel) return team
  }

  return null
}

export function getSimTeamLinkDisplay(value, teams = []) {
  const linkedTeam = findTeamBySimLinkValue(value, teams)
  if (linkedTeam) return getTeamLinkLabel(linkedTeam)
  return normalizeSimTeamLinkValue(value)
}

export function getStoredSimTeamLinkValue(selection, teams = []) {
  const normalizedSelection = normalizeSimTeamLinkValue(selection)
  if (normalizedSelection.length === 0) return ''

  if (LEGACY_SIM_PRICING_MODELS.includes(normalizedSelection)) {
    return normalizedSelection
  }

  const linkedTeam = findTeamBySimLinkValue(normalizedSelection, teams)
  if (linkedTeam && linkedTeam.uuid != null) {
    return String(linkedTeam.uuid).trim()
  }

  return normalizedSelection
}

export function simBelongsToTeam(sim, team, teams = []) {
  if (sim == null || team == null) return false

  const simValue = normalizeSimTeamLinkValue(sim.pricingModel)
  if (simValue.length === 0) return false

  const teamLabel = getTeamLinkLabel(team)
  const teamUuid = String(team.uuid || '').trim()

  if (teamUuid.length > 0 && simValue === teamUuid) return true
  if (teamLabel.length > 0 && simValue === teamLabel) return true

  const linkedTeam = findTeamBySimLinkValue(simValue, teams)
  if (!linkedTeam) return false

  return String(linkedTeam.uuid || '').trim() === teamUuid
}
